import React from 'react';
import './SaveCancelButtons.css';

export const SaveCancelButtons = ({ onCancel, onSave, saveButtonType }) => {
  return (
    <div className="save-cancel-btn-container">
      <button className="save-cancel-btn save-cancel-btn-prev" type="button" onClick={onCancel}>
        <p>Anuluj</p>
      </button>
      <button className={`save-cancel-btn save-cancel-btn-save ${saveButtonType}`} type={`${saveButtonType}`}>
        <p>Zapisz</p>
      </button>
    </div>
  );
};